export default __webpack_public_path__ + "static/media/thoni_915_4.584a39b5.jpg";